export default "__VITE_ASSET__DkPpBXVa__"